import styled from 'styled-components';

import { grey5 } from 'approot/shared/styles/colours.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { rem } from 'approot/shared/style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';
import { ImageStaticWrapper } from 'approot/shared/images/images.style';
import { spacing24 } from 'approot/shared/styles/spacing.style';

export const DrawResponseSuggestedContainer = styled.div`
  ${flexCentreAlignCss}
  border: 1px solid ${grey5};
  border-radius: ${rem(borderRadius8)};
  position: relative;
  margin-bottom: ${rem(spacing24)};

  ${ImageStaticWrapper} {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
  }

  ${ImageStaticWrapper} img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
